
import './App.css';
import 'react-tippy/dist/tippy.css';
import { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import LayoutMobile from 'LayoutMobile';
import LayoutDesktop from 'LayoutDesktop';
import { MessageDialog, useDialogManager } from 'components/dialogs/Dialogs';
import { useZakeke } from 'zakeke-configurator-react';
import LoadingOverlay from './components/widgets/LoadingOverlay';
import useStore from './Store';
import { NodePath } from '@babel/core';

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-flow:column;
  padding:40px 60px;
  @media (max-width: 768px) {
    flex-direction: column;
    padding:0px;
    height: 100%;
  }
  @media (min-width: 1024px) {
    width: 100%;
    height: 100%;
  }
`;

export const Top = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  display: grid;
  grid-template-columns: 1fr 40%;
  min-height:0;

  @media (max-width: 768px) {
    display:flex;
    flex-direction: column;
  }
`;

function App() {

  const [resize, setResize] = useState(false);
  const isMobile = window.innerWidth <= 768;
  const resizeRef = useRef(false);
  resizeRef.current = resize;

  const { showDialog } = useDialogManager();

  const { eventMessages, product, isSceneLoading, isAssetsLoading, culture, currency, groups } = useZakeke();
  const { isLoading, setPriceFormatter, previousCustomizeOptionId, setPreviousCustomizeOptionId, setSelectedGroupId, setSelectedStepId } = useStore();

  // Page resize
  useEffect(() => {
    const resizeFunction = () => {
      setResize(!resizeRef.current);
    }

    window.addEventListener('resize', resizeFunction);
    return () => window.removeEventListener('resize', resizeFunction);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setPriceFormatter(new Intl.NumberFormat(culture, {
      style: "currency",
      currency: currency
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [culture, currency])

  useEffect(() => {
    if (product && !isSceneLoading) {
      const welcomeMessage = eventMessages?.find(message => message.eventID === 3);
      if (welcomeMessage && welcomeMessage.visible)
        showDialog('WelcomeMessage', <MessageDialog alignButtons='center' message={welcomeMessage?.description} />)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [product, isSceneLoading, eventMessages]);

  // auto selection customize group
  useEffect(() => {
    if (groups.length > 0 && groups[0].steps.length > 0) {
      const indexStep = groups[0].steps[groups[0].steps.length - 1].name.toLowerCase().indexOf("custom") ? groups[0].steps.length - 2 : groups[0].steps.length - 1;
      const yesOption = groups[0].steps[indexStep].attributes[0].options.find(x => x.name.toLowerCase() === 'yes' && x.enabled);
      const noOption = groups[0].steps[indexStep].attributes[0].options.find(x => x.name.toLowerCase() === 'no');

      const selectedOption = yesOption?.selected ? yesOption : noOption;

      if (yesOption?.selected && previousCustomizeOptionId !== selectedOption!.id)
        setSelectedStepId(-2);
      setPreviousCustomizeOptionId(selectedOption?.id ?? 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groups]);

  return <>
    {isMobile ? <LayoutMobile /> : <LayoutDesktop />}
    {(isLoading || isSceneLoading || isAssetsLoading) && <LoadingOverlay />}
  </>;
}

export default App;
